/**
 * URL の preview パラメータ
 * 管理画面が GET /{hash}?preview で認可して発行した署名付きトークン（"{expires}.{signature}"）
 */
export const getPreviewToken = (): string =>
  (new URL(window.location.href)).searchParams.get('preview') ?? '';

/**
 * プレビューモードか
 * preview が空でなければプレビューとして振る舞う（トラッキングを送らない等）。
 * 値の正当性はサーバ（/viewer-api/info）が検証し、不正なら 403 を返す
 */
export const isPreview = (): boolean => getPreviewToken() !== '';
